import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { LinkListStyles } from "@insite/content-library/Widgets/Basic/LinkList";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface MemberList {
    fields: {
        videoUrl: string;
    };
}

const enum fields {
    divisions = "divisions",
    linkwrapper = "linkwrapper",
    videoUrl = "videoUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.divisions]: MemberList[];
        [fields.videoUrl]: string;
    };
}

export interface VideoLayoutStyle {
    linkList?: LinkListStyles;
    modal?: ModalPresentationProps;
    linkwrapper?: InjectableCss;
    wrapper?: InjectableCss;
    container?: InjectableCss;
}

export const videoStyle: VideoLayoutStyle = {
    linkwrapper: {
        css: css`
            display: flex;
            justify-content: center;
            button {
                background: #636161;
                border: none;
                &:hover {
                    border: none !important;
                    background: #636161 !important;
                }
            }
        `,
    },
    wrapper: {
        css: css`
            margin-bottom: 40px;
        `,
    },
    container: {
        css: css`
            margin-bottom: 96px;
            width: 100%;
            margin: 0 20px;
            @media all and (max-width: 767px){
                margin: 24px 0;
            }
        `,
    },
};

const styles = videoStyle;

export const CENBrandVideoGallery: FC<OwnProps> = ({ fields }) => {
    const [hideButtonLink, sethideButtonLink] = useState(true);
    const [numberOfVideos, setNumberOfVideos] = useState(fields.divisions.length);

    const hideButton = () => {
        sethideButtonLink(false);
    };

    return (
        <StyledWrapper {...styles.container}>
            {hideButtonLink ? (
                <GridContainer {...styles.wrapper}>
                    {fields.divisions.slice(0, 2)?.map((item, index) => {
                        return (
                            <GridItem width={[12, 12, 6, 6, 6]} key={index}>
                                <iframe width="100%" height="340px" src={item.fields.videoUrl} frameBorder="0"></iframe>
                            </GridItem>
                        );
                    })}
                </GridContainer>
            ) : (
                <GridContainer>
                    {fields.divisions.slice(0, numberOfVideos)?.map((item, index) => {
                        return (
                            <GridItem width={[12, 12, 6, 6, 6]} key={index}>
                                <iframe width="100%" height="340px" src={item.fields.videoUrl} frameBorder="0"></iframe>
                            </GridItem>
                        );
                    })}
                </GridContainer>
            )}
            {hideButtonLink && numberOfVideos > 2 && (
                <StyledWrapper {...styles.linkwrapper}>
                    <Button onClick={hideButton}>Load More</Button>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CENBrandVideoGallery,
    definition: {
        group: "Basic",
        displayName: "CEN Brand Video Gallery",
        fieldDefinitions: [
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.videoUrl;
                },
                defaultValue: [],
                fieldType: "General",
                displayName: "Videos URL",
                fieldDefinitions: [
                    {
                        name: "videoUrl",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
